import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Select from 'react-select';
import { REACT_APP_VAM_ENDPOINT, REACT_APP_VAM_CONTEXT_LITIGATION,REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT } from '../urls';
import { toast } from 'react-toastify';
import {Form } from 'react-bootstrap';
import { editModeOn } from '../utilFunctions';
import { format } from 'date-fns';
import { axiosRequest, axiosWithoutToken } from '../service';
import AsteriskSymbol from '../reusableComponents/AsteriskSymbol';
import { functionalities } from '../consts';
const RemarkorRequest = (props) => {
  const { claimDetailCookie,roleDataCookie } = props;
  const [addRemarks, setAddRemarks] = useState(false);
  const [remarksCookie, setRemarksCookie] = useState()
  const [confiemationForAddingRemarks, setConfirmationForAddingRemarks] = useState(false)
  const [addRemarksButton, setAddRemarksButton] = useState(true)
  const [isActionPending, setIsActionPending] = useState(true);
  const [categoryOptions, setCategoryOptions] = useState([])
  const [assigneeOptions, setAssigneeOptions] = useState([])
  const[emailOptions, setEmailOptions] = useState([])
  const [checkActionPending,setCheckActionPending]=useState(0)
  const [isLoading, setIsLoading] = useState(false);
  const [noOptionPlaceholder,setNoOptionPlaceHolder]=useState('minimum 3 characters required')

 
  useEffect(() => {
    getRemarks(claimDetailCookie?.claimNo)
    getCategoryOptions()
    getAssigneeOptions()
  }, [])

  const handleAddRemark = () => {
    if (claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo) {
      toast.error("Please Assign Claims Handler.")
      return
    }
    setConfirmationForAddingRemarks(true);
    setAddRemarks(false);
    setAddRemarksButton(false)

  }

  const getAssignedTeam =(result)=>{
    const team=assigneeOptions.filter(assignee=>assignee.id===result.assignedTeam).map(assignee=>assignee.value)
    return team
  }
  const [remarksPayload, setRemarksPayload] = useState({
    category: "",
    remarks: "",
    claimId: claimDetailCookie?.claimNo,
    email:"",
    othersCategory:"",
    assignedTeamMemberId:"",
    submittedBy:roleDataCookie?.userID
  })
  const getCategoryOptions = () => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/categories`)
      .then(data => {
        const filteredOptions = data.data.filter(option => option.categoryId !== 1).map(option => ({
          label: option.categoryName,
          value: option.categoryName
        }));
        setCategoryOptions(filteredOptions);
      })
      .catch(e => console.error(e));
  }
   const getAssigneeOptions=()=>{
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/team`).then(data=>{      
      setAssigneeOptions(data.data.map(option => ({id:option.id, label: option.assignedTeam, value: option.assignedTeam })))
    }).catch(e=>console.error(e));
   }
  const getEmail = (value) => {
    // Email Api is Expecting 3 characters
      if (value.length >= 3) {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/email/search?searchKey=${value}`)
          .then((data) => {
            if(data.data.length >0) setEmailOptions(data.data.map(option => ({ label: option, value: option })))
            else setNoOptionPlaceHolder("Search results not found")
          })
          .catch((e) => {
            console.error(e);
          });
      }else if(value.length >0){
        setEmailOptions([])
        setNoOptionPlaceHolder("Minimum 3 characters Required")
      }
};
  useEffect(() => {
    if (remarksCookie?.length) {
      const actionPending = remarksCookie.some(remark => remark.requestStatus !== 'Clear');
      setIsActionPending(actionPending);
    }
  }, [checkActionPending]);
  
  const getRemarks = (claimNumber) => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/getRemarksList/${claimNumber}`).then(response => {
        const data = response.data;
        if (data[0]?.category !== "Open") {
          setRemarksCookie(data);
        }
        setConfirmationForAddingRemarks(false);
        setCheckActionPending(prev => prev + 1);
      })
      .catch(error => {
        console.error(error);
        // toast.error("Something Went Wrong.");
      });
  };
  const clearRemark=(remark)=>{
    if(claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo){
      toast.error("Please Assign Claims Handler.")
      return
  }
    setIsLoading(true)
    setTimeout(()=>{
      axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/updateRequestStatus`,{
        "claimId": claimDetailCookie.claimNo,
        "remarksIdList":[remark?.remarksId],
        "isIndividualAction": true,
        "status": remark.requestStatus==='Action Pending' ? "Clear" : "Action Pending",
        "updatedBy": roleDataCookie.userID,
    }).then(data => {
      getRemarks(claimDetailCookie?.claimNo)
      setCheckActionPending(prev => prev + 1);
      data.data.message==='Data Cleared'? toast.success('Action Flag Cleared'): toast.success('Action Flag Pending')
      setIsLoading(false)
    }).catch(error => {
        console.error(error)
        setIsLoading(false)
        // toast.error("Something Went Wrong.")
      })
    },3000)  
  }
  const addRemark = () => {
    if (remarksPayload.category == "") {
      toast.error("Please select Remarks catogory");
      return
    }
    if (remarksPayload.remarks == "") {
      toast.error("Please enter Remarks");
      return
    } 
    if(remarksPayload.assignedTeamMemberId==0){
      toast.error("please select assigned team")
      return
    }
    if(remarksPayload.category == "Others" && remarksPayload.othersCategory == ""){
      toast.error("Please Enter Category")
      return
    }
 
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/remarksAndRequests`, {
      "claimId": remarksPayload.claimId,
      "remarks": remarksPayload.remarks,
      "category": remarksPayload.category,
      "othersCategory":remarksPayload?.othersCategory ? remarksPayload?.othersCategory :null,
      "assignedTeamMemberId": remarksPayload.assignedTeamMemberId.id ? remarksPayload.assignedTeamMemberId.id  :0,
      "email":remarksPayload.email?remarksPayload.email :"",
      "submittedBy":remarksPayload.submittedBy
    }).then(data => {
      if(data.data.message=='Data Saved Successfully.') toast.success("Remark added successfully")
      else toast.error("The Category and Assigned Team should not be the same unless a clear remark is provided")
      setConfirmationForAddingRemarks(false)
      setRemarksPayload({
        category: "",
        remarks: "",
        claimId: claimDetailCookie?.claimNo,
        othersCategory:"",
        email:"",
        assignedTeamMemberId:"",
        submittedBy:roleDataCookie?.userID
      })
      getRemarks(claimDetailCookie.claimNo)
      setAddRemarksButton(true)
    }).catch(error => {
      console.error(error)
      // toast.error("Something Went Wrong.")
    })
  }
  const clearRemarks = () => {
    if (claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo) {
      toast.error("Please Assign Claims Handler.")
      return
    }
    setIsLoading(true)
    setTimeout(()=>{
      const remarksIdList = remarksCookie
      .filter(remark => remark.requestStatus === (isActionPending ? 'Action Pending' : 'Clear'))
      .map(remark => remark.remarksId);
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/updateRequestStatus`,{
      "claimId": claimDetailCookie.claimNo,
      "remarksIdList": remarksIdList,
      "isIndividualAction": false,
      "status": isActionPending ? "Clear" : "Action Pending",
      "updatedBy": roleDataCookie.userID,
      }).then(data => {
        getRemarks(claimDetailCookie?.claimNo);
        toast.success(data.data.message)
        setIsLoading(false)
      }).catch(error => {
        console.error(error)
        setIsLoading(false)
      })
    },3000)  
  }
  return (
    <>
      <div className='inner-box2Field  mt-3'>
        <div className="detailsHistory">
          <div className='d-flex align-items-end justify-content-between'>
            <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">Remarks & Requests</h3>
            {/* <input type="checkbox" id="toggle" class="toggleCheckbox" checked={!isActionPending} onChange={(e) => {
                    if(claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo){
                        toast.error("Please Assign Claims Handler.")
                        return
                    }
                    setIsActionPending(!isActionPending)
                    clearRemarks();
                    }} />
            <label htmlFor="toggle" class='toggleContainer'>
            {isActionPending ? <span style={{display : 'flex', flexDirection : 'row', justifyContent : 'flex-end', marginRight : '5px'}}> Action Pending </span>  : <span style={{marginLeft : '5px',color:'black'}}> Clear </span>}
            </label> */}
            {
              remarksCookie && remarksCookie.length > 0 && editModeOn(functionalities.REMARKS_REQUEST_SUBMISSION) && (
                <>
                  <div className={`inputWrapper ${isLoading ? 'blur' : ''}`}>
                    <input
                      type="checkbox"
                      id="toggle"
                      className="toggleCheckbox"
                      checked={!isActionPending}
                      onChange={clearRemarks}
                      disabled={isLoading}
                    />
                    <label htmlFor="toggle" className={`toggleContainer ${isLoading ? 'disabled' : ''}`}>
                      <div>Action Pending</div>
                      <div>Clear All</div>
                    </label>
                    {isLoading && <div className="loader-remarks"></div>}
                  </div>
                </>
              )
            }
            {addRemarksButton && editModeOn(functionalities.REMARKS_REQUEST_PAGE) && (<div className="requestCalc" onClick={() =>handleAddRemark()}>Add Remarks</div>)}
            {addRemarks && (<div id="overlay11Field">
              <div className="overlay_textCalc d-flex justify-content-end me-3 m-0"><span className="xCalc glyphicon glyphicon-remove"></span></div>
              <div className="overlay-confirmationField">Are you sure?</div>
              <div onclick="off4()" className="submit-3Field" onClick={() => { setConfirmationForAddingRemarks(true); setAddRemarks(false); setAddRemarksButton(false) }}>Submit</div>
              <div onclick="off4()" className="back1Field" onClick={() => { setConfirmationForAddingRemarks(false); setAddRemarks(false); getRemarks(claimDetailCookie.claimNo); }}>Back</div>
            </div>)}
          </div>
          {confiemationForAddingRemarks && (<div className="top-spaceCalc ms-3">
            <div className="claim_cal_headerCalc">
              <div className="container-fluid align-result-tableCalc">
                <div className="row">
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div className="query-headingCalc">
                      Category <AsteriskSymbol/>
                    </div>
                    <div>
                      <Select
                        options={categoryOptions}
                        placeholder="Select category"
                        value={remarksPayload.category !== "" ? { label: remarksPayload?.category, value: remarksPayload?.category } : null}
                        onChange={(data) => {
                          setRemarksPayload({ ...remarksPayload, category: data.value })
                        }}
                      />
                    </div>
                  </div>
                  {remarksPayload.category === 'Others' && (<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div className="query-headingCalc">
                      <label for="othersCategory"> Enter Category <AsteriskSymbol/> </label>
                    </div>
                    <div>
                      <input type="text"
                      id="othersCategory"
                        className="form-control bg-gray"                       
                        placeholder="Enter category"
                        value={remarksPayload.othersCategory}
                        onChange={(e) => {
                          setRemarksPayload({...remarksPayload, othersCategory: e.target.value })
                        }}
                      />
                    </div>
                  </div>)}
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div class="query-headingCalc">
                     Assign to <AsteriskSymbol/>
                    </div>
                    <div>
                      <Select
                        options={assigneeOptions}
                        placeholder="Select Team"
                        value={remarksPayload.assignedTeamMemberId ? { label: remarksPayload?.assignedTeamMemberId.value, value: remarksPayload?.assignedTeamMemberId.value } :null}
                        onChange={(data) => {
                          setRemarksPayload({ ...remarksPayload, assignedTeamMemberId: data })
                        }}
                      />
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                    <div class="query-headingCalc">
                      Email
                    </div>
                    <div>
                      <Select
                        options={emailOptions}
                        placeholder="Select Email"
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue;
                          getEmail(cleanedValue); // Return cleaned value for the Select component
                      }}
                        value={remarksPayload.email !== "" ? { label: remarksPayload?.email, value: remarksPayload?.email } : null}
                        onChange={(data) => {
                          setRemarksPayload({ ...remarksPayload, email: data.value })
                        }}
                        noOptionsMessage={()=>noOptionPlaceholder}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="query-headingCalc">
                      Remarks <AsteriskSymbol/>
                    </div>
                    <div>
                      <textarea className="remarksAccess bg-gray" onChange={(data) => {
                        setRemarksPayload({ ...remarksPayload, remarks: data.target.value })
                      }}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="overlay-calc">
                <div className="btn btn-outline-danger" onClick={() => { setConfirmationForAddingRemarks(false); getRemarks(claimDetailCookie.claimNo); setAddRemarksButton(true) }}>Cancel</div>
                <div className="btn btn-outline-success ms-2" onClick={() => { addRemark(claimDetailCookie?.claimNo) }}>Submit</div>
              </div>
            </div>
          </div>)}
          {remarksCookie?.length > 0 && !confiemationForAddingRemarks && (remarksCookie.map((result, index) => (<div class="top-space" key={index}>
            <div className="field_detail_headerFieldQC">
              <div className="field-idField">Remark -{result.remarksId}</div>
              <div className="field-statusField">
              {editModeOn(functionalities.REMARKS_REQUEST_SUBMISSION) ? (
                <Form.Check
                type="switch"
                id="disabled-custom-switch"
                label={result.requestStatus ==='Clear'?'Cleared':''}
                checked={result.requestStatus==="Action Pending" ? false : true}
                className="red-checkbox"
                disabled={isLoading}
                onChange={()=> clearRemark(result) }
                />): result.requestStatus ==='Clear'?'Cleared':''}
                    </div>
                </div>
                <div className="container-fluid align-result-tableField">
                  <div id="result-table-rowField" class="row">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <div className="query-headingField">
                        Submission Date &amp; Time
                      </div>
                      <div className="query-answerField">
                        {format(new Date(result?.submissionDate), 'dd-MM-yyyy, hh:mm a')}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <div className="query-headingField">
                        Submitted By
                      </div>
                      <div className="query-answerField">
                        {result?.submittedBy ? result?.submittedBy :"" }
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <div className="query-headingField">
                        Category
                      </div>
                      <div className="query-answerField">
                        {result?.category} {result?.category==='Others' ?'-' +" "+ result?.othersCategory !== null ? result?.othersCategory:'' :''}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                  <div className="query-headingField">
                   Assigned To
                  </div>
                  <div className="query-answerField">
                    {getAssignedTeam(result) }
                  </div>
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                  <div className="query-headingField">
                    Email
                  </div>
                  <div className="query-answerField">
                    {result?.assignedTeamMemberMail ? result?.assignedTeamMemberMail :""}
                  </div>
                  </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                  <div className="query-headingField">
                    Remarks
                  </div>
                  <div className="query-answerField">
                    {result?.remarks}
                  </div>
                </div>
              </div>
            </div>
          </div>)))}
        </div>
      </div>
    </>
  )
}

export default RemarkorRequest
